import React from 'react';

export type LanguageKey = 'ua' | 'en' | 'de';

export const LANGUAGE_OPTIONS: { key: LanguageKey; label: string }[] = [
  { key: 'ua', label: 'Українська' },
  { key: 'en', label: 'Англійська' },
  { key: 'de', label: 'Німецька' },
];

export function getLanguageTabId(prefix: string, key: LanguageKey) {
  return `${prefix}-tab-${key}`;
}

export function getLanguagePanelId(prefix: string, key: LanguageKey) {
  return `${prefix}-panel-${key}`;
}

type Props = {
  activeLanguage: LanguageKey;
  onChange: (language: LanguageKey) => void;
  idPrefix: string;
  ariaLabel?: string;
  className?: string;
};

export default function LanguageTabs({
  activeLanguage,
  onChange,
  idPrefix,
  ariaLabel = 'Мова',
  className,
}: Props) {
  return (
    <div
      className={`language-tabs ${className ?? ''}`.trim()}
      role="tablist"
      aria-label={ariaLabel}
    >
      {LANGUAGE_OPTIONS.map(language => {
        const isActive = language.key === activeLanguage;
        return (
          <button
            key={language.key}
            type="button"
            role="tab"
            id={getLanguageTabId(idPrefix, language.key)}
            aria-controls={getLanguagePanelId(idPrefix, language.key)}
            aria-selected={isActive}
            className={`language-tab ${isActive ? 'is-active' : ''}`}
            onClick={() => onChange(language.key)}
          >
            {language.label}
          </button>
        );
      })}
    </div>
  );
}
